module.exports = __webpack_public_path__ + "static/5-4f384b75f8edafe79aa1e86d975b2952.png";